import React from 'react';
import BaseModal from '../../common/ModalWindows/BaseModal';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';

function BasicForm(props) {
  const { children, cancel, blue } = props;
  const size = useWindowSize();

  return (
    <BaseModal
      open
      fullscreen={size.width < MOBILE_BREAKPOINT}
      closeHandler={cancel}
      confirmHandler={() => {}}
      title=""
      onlyConfirm
      onlyReject
      hideHeader
      hideFooter
      container={size.width < MOBILE_BREAKPOINT ? () => document.getElementById('quick-apply-container') : null}
      backgroundColor={blue ? '#003B58' : null}
      marginLeftRight={size.width < MOBILE_BREAKPOINT ? 1 : 4}
    >
      <div
        style={{ position: size.width < MOBILE_BREAKPOINT ? 'sticky' : 'static', left: '0', right: '0', top: '80px' }}
      >
        {children}
      </div>
    </BaseModal>
  );
}

export default BasicForm;
